import { Skeleton } from "@/shadcnComponents/ui/skeleton";

export const DashboardSkeleton = ({
  hideSidebar,
  hideNavbar,
}: {
  hideSidebar?: boolean;
  hideNavbar?: boolean;
}) => {
  return (
    <div
      className={`  flex flex-col items-start overflow-hidden ${
        hideSidebar ? "w-full h-full" : "w-screen h-screen"
      } `}
    >
      <section className="w-full h-full flex items-start overflow-hidden">
        {/* Sidebar */}
        <div
          className={` hidden md:flex h-full  md:flex-col w-[260px] min-w-[260px] border-r-[1px] border-[#262626] p-5 box-border gap-5 font-inter z-10 bg-[#171717;] ${
            hideSidebar ? "hidden md:hidden" : ""
          }`}
          style={{
            boxShadow: "4px 0px 8px 0px rgba(33, 33, 33, 0.08)",
            overflowY: "auto",
            scrollbarWidth: "none",
          }}
        >
          <img
            src={
              // "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/anchors_Christmas.svg"
              // "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/DiwaliLogoBlack.png"
              // "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/Collab+White+Logo.svg"
              "https://anchors-assets.s3.ap-south-1.amazonaws.com/anchors+logo+with+white+text.png"
            }
            alt=""
            className="w-44 mb-5 cursor-pointer"
          />
          {/* userinfo header */}
          <div className="flex items-center gap-2">
            <Skeleton className="bg-[#A3A3A3] w-10 h-10 rounded-full" />
            <section className="flex flex-col gap-1">
              <Skeleton className="bg-[#A3A3A3]  w-40 h-5" />
              <Skeleton className="bg-[#A3A3A3]  w-24 h-3" />
            </section>
          </div>
          {/* user public profile header */}
          <Skeleton className="bg-[#A3A3A3] rounded-lg h-8 w-full " />
        </div>

        <section className="w-full h-full flex flex-col items-center ">
          {/* Navbar */}
          <div
            className={`w-full box-border px-5 py-3 flex items-center flex-row-reverse gap-4 md:gap-8 bg-[#171717] border-b-[1px] border-[#262626] relative ${
              hideNavbar ? "hidden" : ""
            }`}
          >
            <Skeleton className="bg-[#A3A3A3] rounded-full w-10 h-10" />
            <div className="absolute left-[16px] md:left-[28%] flex items-center justify-center text-xs font-inter gap-5">
              <img
                src={
                  "https://anchors-assets.s3.ap-south-1.amazonaws.com/anchors+logo+with+white+text.png"
                }
                alt=""
                className="w-20 md:hidden  cursor-pointer"
              />
              <span className="bg-[#381c1c] py-2 px-3 border-none rounded-md text-[#ffffff] hidden md:flex items-center gap-2 cursor-pointer">
                <span className="bg-[#381c1c]  px-3 border-none rounded-lg text-[#FFFFFF] hidden md:flex items-center gap-2 cursor-pointer">
                  <Skeleton className="bg-[#A3A3A3] rounded-full w-[16px] h-[16px]" />
                  <Skeleton className="bg-[#A3A3A3] w-24 h-2 " />
                </span>
              </span>
              <span className="bg-[#381c1c] py-2 px-3 border-none rounded-md text-[#ffffff] hidden md:flex items-center gap-2 cursor-pointer">
                <span className="bg-[#381c1c]  px-3 border-none rounded-lg text-[#FFFFFF] hidden md:flex items-center gap-2 cursor-pointer">
                  <Skeleton className="bg-[#A3A3A3] rounded-full w-[16px] h-[16px]" />
                  <Skeleton className="bg-[#A3A3A3] w-24 h-2 " />
                </span>
              </span>
            </div>
          </div>
          <div className="bg-[#171717] w-full h-screen overflow-x-hidden overflow-y-auto">
            <div className="w-full relative  h-max items-start flex p-[16px] md:p-[40px]  pb-[100px] md:pb-[16px] gap-[15px] ">
              <div className="w-full md:w-[80%] flex flex-wrap  gap-4 ">
                <div className="flex flex-col md:flex-row gap-5 justify-center w-full  ">
                  <Skeleton className="md:w-1/2 h-[180px] bg-[#A3A3A3] " />
                  <Skeleton className="md:w-1/2 h-[180px] bg-[#A3A3A3] " />
                </div>
                <Skeleton className="bg-[#A3A3A3] min-w-[296px] min-h-[317px] flex flex-col justify-center items-center gap-3 flex-[1_0_0] self-stretch p-5 border border-neutral-800 rounded-md" />
                <Skeleton className="bg-[#A3A3A3] min-w-[296px] min-h-[317px] flex flex-col justify-center items-center gap-3 flex-[1_0_0] self-stretch p-5 border border-neutral-800 rounded-md" />
                <Skeleton className="bg-[#A3A3A3] min-w-[296px] min-h-[317px] flex flex-col justify-center items-center gap-3 flex-[1_0_0] self-stretch p-5 border border-neutral-800 rounded-md" />
                <Skeleton className="bg-[#A3A3A3] min-w-[296px] min-h-[317px] flex flex-col justify-center items-center gap-3 flex-[1_0_0] self-stretch p-5 border border-neutral-800 rounded-md" />
                <Skeleton className="bg-[#A3A3A3] min-w-[296px] min-h-[317px] flex flex-col justify-center items-center gap-3 flex-[1_0_0] self-stretch p-5 border border-neutral-800 rounded-md" />
                <Skeleton className="bg-[#A3A3A3] min-w-[296px] min-h-[317px] flex flex-col justify-center items-center gap-3 flex-[1_0_0] self-stretch p-5 border border-neutral-800 rounded-md" />
              </div>
              <div className="hidden md:block sticky top-10 space-y-10">
                <Skeleton className="bg-[#A3A3A3] w-[200px] h-[150px] flex items-center gap-3" />
                <Skeleton className="bg-[#A3A3A3] w-[200px] h-[350px] flex items-center gap-3" />
              </div>
            </div>
          </div>
        </section>
      </section>
    </div>
  );
};
